import { motion } from "framer-motion"

const pageVariants = {
    initial: {
        opacity: 0,
    },
    in: {
        opacity: 1,
    },
    out: {
        opacity: 0,
    },
}

export function PageWrapper(props: { children: any }) {
    const { children } = props;
    return <motion.div initial="initial" style={{ padding: "16px 16px" }}
        animate="in" exit="out" variants={pageVariants}>{children}</motion.div>
}